import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled, { default as _styled2 } from "styled-components";
var _Checkmark, _templateObject;
var _excluded = ["jsxLabel", "label", "selected", "clampText", "isDark", "dark", "isTransparency", "transparencyMode", "className", "datatestid", "data-testid", "href", "onClick", "htmlProps"];
import { Fragment } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import Checkmark from '@crehana/icons/outline/Checkmark';
import parseClassnames from "../helpers/parseClassnames";
import { greenMain } from "../styles/colors";
import { OPTION, OPTION_DARK, OPTION_TRANSPARENCY } from "./classnames";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MenuItem = function MenuItem(_ref) {
  var jsxLabel = _ref.jsxLabel,
    label = _ref.label,
    selected = _ref.selected,
    clampText = _ref.clampText,
    isDark = _ref.isDark,
    dark = _ref.dark,
    isTransparency = _ref.isTransparency,
    transparencyMode = _ref.transparencyMode,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    datatestid = _ref.datatestid,
    dataTestId = _ref['data-testid'],
    href = _ref.href,
    onClick = _ref.onClick,
    htmlProps = _ref.htmlProps,
    menuItemProps = _objectWithoutProperties(_ref, _excluded);
  var menuItemClassNames = isDark || dark ? OPTION_DARK : OPTION;
  if (isTransparency || transparencyMode) {
    menuItemClassNames = OPTION_TRANSPARENCY;
  }
  var wrapperClassNames = parseClassnames(className, menuItemClassNames);
  var wrapperCss = /*#__PURE__*/css(["\n    transition: ", ";\n  "], function (_ref2) {
    var theme = _ref2.theme;
    return theme.transition(['background-color', 'color']);
  });
  var renderChildren = function renderChildren() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: cn('font-body3 overflow-hidden max-h-24', {
          'pr-16': selected,
          'break-all truncate': clampText
        }),
        children: jsxLabel || label
      }), selected && (_Checkmark || (_Checkmark = /*#__PURE__*/_jsx(Checkmark, {
        size: 24,
        color: greenMain
      })))]
    });
  };
  if (href) {
    return /*#__PURE__*/_jsx(_StyledA, _objectSpread(_objectSpread(_objectSpread({
      className: wrapperClassNames,
      "data-testid": dataTestId || datatestid,
      href: href,
      onClick: onClick
    }, menuItemProps), htmlProps), {}, {
      $_css: wrapperCss,
      children: renderChildren()
    }));
  }
  return /*#__PURE__*/_jsx(_StyledButton, _objectSpread(_objectSpread(_objectSpread({
    type: "button",
    className: wrapperClassNames,
    "data-testid": dataTestId || datatestid,
    onClick: onClick
  }, menuItemProps), htmlProps), {}, {
    $_css2: wrapperCss,
    children: renderChildren()
  }));
};
export default MenuItem;
var _StyledA = /*#__PURE__*/_styled("a")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledButton = /*#__PURE__*/_styled2("button").withConfig({
  componentId: "sc-e49a8c-0"
})(["", ""], function (p) {
  return p.$_css2;
});